import { render, staticRenderFns } from "./BillingBmCodelkupIndex.vue?vue&type=template&id=5b193d2a&scoped=true&"
import script from "./BillingBmCodelkupIndex.vue?vue&type=script&lang=js&"
export * from "./BillingBmCodelkupIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193d2a",
  null
  
)

export default component.exports